"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _popup_container = _interopRequireDefault(require("../popup_container"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _popup_styles = _interopRequireDefault(require("../popup_styles"));

var _delete_definition = _interopRequireDefault(require("./delete_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// definition

/* ========== ~~~~~~~~~~ MESSAGE : POPUP : DELETE : CHILD ~~~~~~~~~~ ========== */


var DeleteMessage = (0, _reactJss.default)(_popup_styles.default)(function (props) {
  return _react.default.createElement(_popup_container.default, {
    type: 'delete',
    title: 'Delete Confirmation',
    body: _react.default.createElement("p", null, "Are you sure you want to delete ", props.itemType && props.itemName ? _react.default.createElement("span", null, "the ", props.itemType, " ", _react.default.createElement("strong", {
      className: 'clump'
    }, "\"", props.itemName, "\""), "?") : _react.default.createElement("span", null, "this item?")),
    buttonPrimary: {
      text: 'Delete',
      variant: 'delete',
      action: props.primaryAction
    },
    buttonSecondary: {
      text: 'Cancel',
      variant: 'system',
      action: props.secondaryAction
    }
  });
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(DeleteMessage, _delete_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = DeleteMessage;
exports.default = _default;